function convertGender(value) {
    if(value == 'M'){
      return '남자';
    }else if(value == 'F'){
      return '여자';
    }else if(value == 'MF'){
      return '남녀 전체';
    }
}

module.exports = {
  paseTarget: function(target) {
    var targetObj = {};
    var gender= {
        label: '남녀 전체',
        value: 'MF'
    }
    switch (target) {
      case 'MF769':
        targetObj.minAge = '7'
        targetObj.maxAge = '69'
        gender.label = '남녀 전체';
        gender.value = 'MF';
        targetObj.gender = gender;
        break;
      case 'M769':
        targetObj.minAge = '7'
        targetObj.maxAge = '69'
        gender.label = '남자';
        gender.value = 'M';
        targetObj.gender = gender;
        break;
      case 'F769':
        targetObj.minAge = '7'
        targetObj.maxAge = '69'
        gender.label = '여자';
        gender.value = 'F';
        targetObj.gender = gender;
        break;
      default:
        if(target.length == 5){
          gender.value = target.substring(0,1);
          targetObj.minAge = target.substring(1,3);
          targetObj.maxAge = target.substring(3,5);
          gender.label = convertGender(gender.value);
        }else if(target.length == 6){
          gender.value = target.substring(0,2);
          targetObj.minAge = target.substring(2,4);
          targetObj.maxAge = target.substring(4,6);
          gender.label = convertGender(gender.value);
        }
        targetObj.gender = gender;
        break;
    }
    return targetObj;
  },
}



// WEBPACK FOOTER //
// ./src/views/common/ReachUtils.js